export default __webpack_public_path__ + "b8ccc40cefbd568f22b0f544017ff9e0.svg";